export type Lang = 'en' | 'bm';

export type AppTranslations = {
  home: {
    line1: string;
    line2: string;
    line3: string;
    line4: string;
    line5: string;
    line6: string;
  };
  ageSmoker: {
    title: string;
    smokerQuestion: string;
    yes: string;
    no: string;
    submit: string;
    allRequiredWarning: string;
  };
  pdpa: {
    title: string;
    consentText: string;
    agree: string;
    decline: string;
    consentWarning: string;
    noticeTitle: string;
  };
  phone: {
    instruction: string;
    mobileLabel: string;
    requestOtpButton: string;
    mobileWarning: string;
    otpError: string;
    maxSubmissionsWarning: string;
    turnstileFailed: string;
    confirmTitle: string;
    confirmMobileLabel: string;
    confirmPrompt: string;
    verifyingSecurity: string;
    back: string;
    confirm: string;
  };
  otp: {
    sentMessage: string;
    otpCodeLabel: string;
    submit: string;
    emptyWarning: string;
    verifyError: string;
    profileNotFoundWarning: string;
    waitBeforeSubmit: string;
    readyToSubmit: string;
  };
  thankYou: {
    line1: string;
    line2: string;
  };
  custCompleted: {
    line1: string;
    line2: string;
    line3: string;
  };
  surveyContinue: {
    message: string;
    setBMessage: string;
  };
  setAProfile: {
    title: string;
    nameLabel: string;
    emailLabel: string;
    raceLabel: string;
    stateLabel: string;
    areaLabel: string;
    selectRace: string;
    selectState: string;
    continue: string;
    nameWarning: string;
    emailWarning: string;
    raceWarning: string;
    stateWarning: string;
    areaWarning: string;
    areaLengthWarning: string;
    incompleteWarning: string;
  };
  prevBrand: {
    question: string;
    loading: string;
    loadError: string;
    requiredWarning: string;
    otherSpecify: string;
    otherSpecifyWarning: string;
    continue: string;
  };
  prevBrandAnswer: {
    whyQuestion: string;
    taste: string;
    price: string;
    productFeatures: string;
    brandCredibility: string;
    peersSmoking: string;
    otherReasons: string;
    elaborateHint: string;
    otherProductQuestion: string;
    selectYesNo: string;
    yes: string;
    no: string;
    continue: string;
    reasonRequiredWarning: string;
    tasteElaborationWarning: string;
    priceElaborationWarning: string;
    productFeaturesElaborationWarning: string;
    brandCredibilityElaborationWarning: string;
    peersSmokingElaborationWarning: string;
    otherProductWarning: string;
  };
  prevBrandAnswerOther: {
    smokeFrequencyQuestion: string;
    smokeFrequencyWarning: string;
    firstProduct: string;
    secondProduct: string;
    times: string;
  };
  ldProductNow: {
    variantQuestion: string;
    selectVariant: string;
    loading: string;
    loadError: string;
    motivationQuestion: string;
    productQuality: string;
    price: string;
    peerRecommendation: string;
    strongTaste: string;
    smoothDelivery: string;
    mentholFlavorExperience: string;
    otherSpecify: string;
    otherProductQuestion: string;
    selectYesNo: string;
    yes: string;
    no: string;
    continue: string;
    variantWarning: string;
    motivationWarning: string;
    otherMotivationWarning: string;
    otherProductWarning: string;
  };
  whyNotLd: {
    question: string;
    placeholder: string;
    submit: string;
    answerWarning: string;
    sessionExpiredWarning: string;
    incompleteWarning: string;
    submitError: string;
  };
  setBLdBrandOpinion: {
    brandOpinionQuestion: string;
    brandOpinionPlaceholder: string;
    futureLikelihoodQuestion: string;
    selectLikelihood: string;
    whyQuestion: string;
    submit: string;
    brandOpinionWarning: string;
    likelihoodWarning: string;
    likelihoodWhyWarning: string;
    sessionExpiredWarning: string;
    incompleteWarning: string;
    submitError: string;
  };
  tng: {
    title: string;
    subtitle: string;
    smsNote: string;
    fallbackNote: string;
  };
};

const en: AppTranslations = {
  home: {
    line1: 'Respondents who complete the',
    line2: 'survey will be provided a token',
    line3: "of appreciation.* T&C apply.",
    line4: 'Choose your language to',
    line5: 'proceed if you agree to',
    line6: 'participate in the survey.',
  },
  ageSmoker: {
    title: 'Age',
    smokerQuestion: 'Are you a smoker?',
    yes: 'Yes',
    no: 'No',
    submit: 'Submit',
    allRequiredWarning: 'Please answer all questions before continuing to the next page.',
  },
  pdpa: {
    title: 'PDPA',
    consentText: 'I hereby confirm my consent to the processing of my personal data as set out above.',
    agree: 'Agree',
    decline: 'Decline',
    consentWarning: 'Please tick the terms and condition to continue.',
    noticeTitle: 'NOTICE UNDER THE PERSONAL DATA PROTECTION ACT 2010 ("PDPA")',
  },
  phone: {
    instruction: 'Please input your mobile number for us to send you an OTP.',
    mobileLabel: 'Mobile No.:',
    requestOtpButton: 'Request OTP',
    mobileWarning: 'Please enter your mobile number.',
    otpError: 'Unable to send OTP. Please try again.',
    maxSubmissionsWarning: 'Maximum survey submissions reached for this phone number.',
    turnstileFailed:
      'Security check could not complete. Please check your internet connection and try again.',
    confirmTitle: 'You have entered:',
    confirmMobileLabel: 'Mobile No: ',
    confirmPrompt: 'Please confirm the information is correct.',
    verifyingSecurity: 'Security verification in progress. Please wait...',
    back: 'Back',
    confirm: 'Confirm',
  },
  otp: {
    sentMessage: 'OTP has been sent to your mobile no.:',
    otpCodeLabel: 'OTP Code:',
    submit: 'Submit',
    emptyWarning: 'Please enter the OTP code.',
    verifyError: 'Unable to verify OTP. Please try again.',
    profileNotFoundWarning:
      'We could not load your profile from your previous survey. Please contact support.',
    waitBeforeSubmit:
      'Wait {{seconds}}s before tapping Submit. You can type the code while you wait.',
    readyToSubmit: 'You can tap Submit now.',
  },
  thankYou: {
    line1: 'THANK YOU',
    line2: 'FOR YOUR PARTICIPATION',
  },
  custCompleted: {
    line1: 'Thank you for your interest!',
    line2: "You've already completed",
    line3: 'this survey.',
  },
  surveyContinue: {
    message: 'Survey questions coming soon.',
    setBMessage: 'Set B — next step coming soon.',
  },
  setAProfile: {
    title: 'Your details',
    nameLabel: 'Name',
    emailLabel: 'Email',
    raceLabel: 'Race',
    stateLabel: 'State of Residences',
    areaLabel: 'Please specify your area of residence',
    selectRace: 'Select race',
    selectState: 'Select state',
    continue: 'Continue',
    nameWarning: 'Please enter your name.',
    emailWarning: 'Please enter a valid email address.',
    raceWarning: 'Please select your race.',
    stateWarning: 'Please select your state of residence.',
    areaWarning: 'Please specify your area of residence.',
    areaLengthWarning: 'Area of residence must not exceed 160 characters.',
    incompleteWarning: 'Please complete all fields before continuing.',
  },
  prevBrand: {
    question: 'What is your previous smoking brand?',
    loading: 'Loading brands...',
    loadError: 'Unable to load brands. Please try again.',
    requiredWarning: 'Please choose a brand variant before continuing.',
    otherSpecify: 'Others. Please specify:',
    otherSpecifyWarning: 'Please specify your brand.',
    continue: 'Continue',
  },
  prevBrandAnswer: {
    whyQuestion: 'Why did you smoke your previous brand?',
    taste: 'Taste',
    price: 'Price',
    productFeatures: 'Product features',
    brandCredibility: 'Brand credibility',
    peersSmoking: 'My peers smoke the same brand',
    otherReasons: 'Other reasons, please specify:',
    elaborateHint: 'Please elaborate more',
    otherProductQuestion: 'Did you smoke any product other than your previous main product?',
    selectYesNo: 'Yes/No',
    yes: 'Yes',
    no: 'No',
    continue: 'Continue',
    reasonRequiredWarning: 'Please select at least one reason.',
    tasteElaborationWarning: 'Please elaborate on Taste.',
    priceElaborationWarning: 'Please elaborate on Price.',
    productFeaturesElaborationWarning: 'Please elaborate on Product features.',
    brandCredibilityElaborationWarning: 'Please elaborate on Brand credibility.',
    peersSmokingElaborationWarning: 'Please elaborate on My peers smoke the same brand.',
    otherProductWarning: 'Please answer whether you smoked any other product.',
  },
  prevBrandAnswerOther: {
    smokeFrequencyQuestion:
      'Out of 10 times you smoke, how many times is first product & how many times is second product?',
    smokeFrequencyWarning: 'Please move the slider to answer this question.',
    firstProduct: 'First Product',
    secondProduct: 'Second Product',
    times: 'times',
  },
  ldProductNow: {
    variantQuestion: 'Which LD product do you currently smoke?',
    selectVariant: 'Choose variant',
    loading: 'Loading variants...',
    loadError: 'Unable to load LD variants. Please try again.',
    motivationQuestion: 'What motivates you to buy LD again?',
    productQuality: 'Product quality',
    price: 'Price',
    peerRecommendation: 'Peer recommendation',
    strongTaste: 'Strong taste',
    smoothDelivery: 'Smooth delivery',
    mentholFlavorExperience: 'Menthol & flavor experience',
    otherSpecify: 'Others, please specify:',
    otherProductQuestion: 'Do you smoke other product than LD?',
    selectYesNo: 'Yes/No',
    yes: 'Yes',
    no: 'No',
    continue: 'Continue',
    variantWarning: 'Please select your LD variant.',
    motivationWarning: 'Please select at least one motivation.',
    otherMotivationWarning: 'Please specify your other motivation.',
    otherProductWarning: 'Please answer whether you smoke other products than LD.',
  },
  whyNotLd: {
    question: 'What stopped you from trying LD before this?',
    placeholder: 'Type your answer here',
    submit: 'Submit',
    answerWarning: 'Please enter your answer before continuing.',
    sessionExpiredWarning: 'Session expired. Please start again from the phone step.',
    incompleteWarning: 'Survey data is incomplete. Please go back and complete the previous steps.',
    submitError: 'Unable to save. Please try again.',
  },
  setBLdBrandOpinion: {
    brandOpinionQuestion: 'What do you think of brand LD?',
    brandOpinionPlaceholder: 'Type your answer here',
    futureLikelihoodQuestion:
      'On a scale of 1 to 5, how likely are you to consume LD as your main product in the future? (1= not at all, 5= most likely)',
    selectLikelihood: '1-5',
    whyQuestion: 'Why?',
    submit: 'Submit',
    brandOpinionWarning: 'Please share your thoughts on brand LD.',
    likelihoodWarning: 'Please select a score from 1 to 5.',
    likelihoodWhyWarning: 'Please tell us why you chose that score.',
    sessionExpiredWarning: 'Session expired. Please start again from the phone step.',
    incompleteWarning: 'Survey data is incomplete. Please go back and complete the previous steps.',
    submitError: 'Unable to save. Please try again.',
  },
  tng: {
    title: 'THANK YOU',
    subtitle: 'FOR YOUR PARTICIPATION',
    smsNote: 'You will receive the e-Wallet redemption PIN via SMS',
    fallbackNote:
      'Your voucher could not be loaded in this view. If you just completed the survey, open this page from the survey step again in the same browser tab.',
  },
};

const bm: AppTranslations = {
  home: {
    line1: 'Responden yang melengkapkan',
    line2: 'kaji selidik akan diberikan token',
    line3: 'penghargaan.* T&S terpakai.',
    line4: 'Pilih bahasa anda untuk',
    line5: 'meneruskan jika anda bersetuju',
    line6: 'untuk menyertai kaji selidik.',
  },
  ageSmoker: {
    title: 'Umur',
    smokerQuestion: 'Adakah anda perokok?',
    yes: 'Ya',
    no: 'Tidak',
    submit: 'Hantar',
    allRequiredWarning: 'Sila jawab semua soalan sebelum meneruskan ke halaman seterusnya.',
  },
  pdpa: {
    title: 'PDPA',
    consentText:
      'Dengan ini saya bersetuju dan mengesahkan persetujuan saya untuk memprocess data peribadi saya seperti dinyatakan di atas.',
    agree: 'Setuju',
    decline: 'Tidak Setuju',
    consentWarning: 'Sila tandakan kotak pilihan untuk mengesahkan persetujuan anda',
    noticeTitle: 'NOTIS DI BAWAH AKTA PERLINDUNGAN DATA PERIBADI 2010 (“PDPA")',
  },
  phone: {
    instruction: 'Sila masukkan nombor telefon bimbit anda untuk kami menghantar OTP.',
    mobileLabel: 'No. Telefon:',
    requestOtpButton: 'Minta OTP',
    mobileWarning: 'Sila masukkan nombor telefon bimbit anda.',
    otpError: 'Tidak dapat menghantar OTP. Sila cuba lagi.',
    maxSubmissionsWarning: 'Had maksimum penyertaan kaji selidik untuk nombor telefon ini telah dicapai.',
    turnstileFailed:
      'Pemeriksaan keselamatan tidak dapat diselesaikan. Sila semak sambungan internet anda dan cuba lagi.',
    confirmTitle: 'Anda telah memasukkan:',
    confirmMobileLabel: 'No. Telefon: ',
    confirmPrompt: 'Sila sahkan maklumat adalah betul.',
    verifyingSecurity: 'Pengesahan keselamatan sedang diproses. Sila tunggu...',
    back: 'Kembali',
    confirm: 'Sahkan',
  },
  otp: {
    sentMessage: 'OTP telah dihantar ke no. telefon bimbit anda:',
    otpCodeLabel: 'Kod OTP:',
    submit: 'Hantar',
    emptyWarning: 'Sila masukkan kod OTP.',
    verifyError: 'Tidak dapat mengesahkan OTP. Sila cuba lagi.',
    profileNotFoundWarning:
      'Profil anda daripada kaji selidik sebelumnya tidak dapat dimuatkan. Sila hubungi sokongan.',
    waitBeforeSubmit:
      'Tunggu {{seconds}}s sebelum mengetik Hantar. Anda boleh taip kod semasa menunggu.',
    readyToSubmit: 'Anda boleh mengetik Hantar sekarang.',
  },
  thankYou: {
    line1: 'TERIMA KASIH',
    line2: 'ATAS PENYERTAAN ANDA',
  },
  custCompleted: {
    line1: 'Terima kasih atas minat anda!',
    line2: 'Anda telah melengkapkan',
    line3: 'kaji selidik ini.',
  },
  surveyContinue: {
    message: 'Soalan kaji selidik akan datang tidak lama lagi.',
    setBMessage: 'Set B — langkah seterusnya akan datang tidak lama lagi.',
  },
  setAProfile: {
    title: 'Butiran anda',
    nameLabel: 'Nama',
    emailLabel: 'E-mel',
    raceLabel: 'Bangsa',
    stateLabel: 'Negeri Kediaman',
    areaLabel: 'Sila nyatakan kawasan kediaman anda',
    selectRace: 'Pilih bangsa',
    selectState: 'Pilih negeri',
    continue: 'Teruskan',
    nameWarning: 'Sila masukkan nama anda.',
    emailWarning: 'Sila masukkan alamat e-mel yang sah.',
    raceWarning: 'Sila pilih bangsa anda.',
    stateWarning: 'Sila pilih negeri kediaman anda.',
    areaWarning: 'Sila nyatakan kawasan kediaman anda.',
    areaLengthWarning: 'Kawasan kediaman tidak boleh melebihi 160 aksara.',
    incompleteWarning: 'Sila lengkapkan semua medan sebelum meneruskan.',
  },
  prevBrand: {
    question: 'Apakah jenama rokok anda sebelum ini?',
    loading: 'Memuatkan jenama...',
    loadError: 'Tidak dapat memuatkan senarai jenama. Sila cuba lagi.',
    requiredWarning: 'Sila pilih varian jenama sebelum meneruskan.',
    otherSpecify: 'Lain-lain. Sila nyatakan:',
    otherSpecifyWarning: 'Sila nyatakan jenama anda.',
    continue: 'Teruskan',
  },
  prevBrandAnswer: {
    whyQuestion: 'Mengapa anda merokok jenama anda sebelum ini?',
    taste: 'Rasa',
    price: 'Harga',
    productFeatures: 'Ciri produk',
    brandCredibility: 'Kredibiliti jenama',
    peersSmoking: 'Rakan sebaya saya merokok jenama yang sama',
    otherReasons: 'Sebab lain, sila nyatakan:',
    elaborateHint: 'Sila jelaskan dengan lebih lanjut',
    otherProductQuestion: 'Adakah anda merokok produk lain selain produk utama anda sebelum ini?',
    selectYesNo: 'Ya/Tidak',
    yes: 'Ya',
    no: 'Tidak',
    continue: 'Teruskan',
    reasonRequiredWarning: 'Sila pilih sekurang-kurangnya satu sebab.',
    tasteElaborationWarning: 'Sila jelaskan tentang Rasa.',
    priceElaborationWarning: 'Sila jelaskan tentang Harga.',
    productFeaturesElaborationWarning: 'Sila jelaskan tentang Ciri produk.',
    brandCredibilityElaborationWarning: 'Sila jelaskan tentang Kredibiliti jenama.',
    peersSmokingElaborationWarning:
      'Sila jelaskan tentang Rakan sebaya saya merokok jenama yang sama.',
    otherProductWarning: 'Sila jawab sama ada anda merokok produk lain.',
  },
  prevBrandAnswerOther: {
    smokeFrequencyQuestion:
      'Daripada 10 kali anda merokok, berapa kali produk pertama & berapa kali produk kedua?',
    smokeFrequencyWarning: 'Sila gerakkan peluncur untuk menjawab soalan ini.',
    firstProduct: 'Produk Pertama',
    secondProduct: 'Produk Kedua',
    times: 'kali',
  },
  ldProductNow: {
    variantQuestion: 'Produk LD manakah yang anda sedang merokok?',
    selectVariant: 'Pilih varian LD',
    loading: 'Memuatkan varian...',
    loadError: 'Tidak dapat memuatkan varian LD. Sila cuba lagi.',
    motivationQuestion: 'Apakah yang mendorong anda membeli LD lagi?',
    productQuality: 'Kualiti produk',
    price: 'Harga',
    peerRecommendation: 'Cadangan rakan sebaya',
    strongTaste: 'Rasa yang kuat',
    smoothDelivery: 'Penghantaran yang lancar',
    mentholFlavorExperience: 'Pengalaman mentol & perisa',
    otherSpecify: 'Lain-lain, sila nyatakan:',
    otherProductQuestion: 'Adakah anda merokok produk lain selain LD?',
    selectYesNo: 'Ya/Tidak',
    yes: 'Ya',
    no: 'Tidak',
    continue: 'Teruskan',
    variantWarning: 'Sila pilih varian LD anda.',
    motivationWarning: 'Sila pilih sekurang-kurangnya satu motivasi.',
    otherMotivationWarning: 'Sila nyatakan motivasi lain anda.',
    otherProductWarning: 'Sila jawab sama ada anda merokok produk lain selain LD.',
  },
  whyNotLd: {
    question: 'Apakah yang menghalang anda daripada mencuba LD sebelum ini?',
    placeholder: 'Taip jawapan anda di sini',
    submit: 'Hantar',
    answerWarning: 'Sila masukkan jawapan anda sebelum meneruskan.',
    sessionExpiredWarning: 'Sesi tamat. Sila mulakan semula dari langkah telefon.',
    incompleteWarning: 'Data kaji selidik tidak lengkap. Sila kembali dan lengkapkan langkah sebelumnya.',
    submitError: 'Tidak dapat menyimpan. Sila cuba lagi.',
  },
  setBLdBrandOpinion: {
    brandOpinionQuestion: 'Apakah pendapat anda tentang jenama LD?',
    brandOpinionPlaceholder: 'Taip jawapan anda di sini',
    futureLikelihoodQuestion:
      'Pada skala 1 hingga 5, sejauh manakah kemungkinan anda menggunakan LD sebagai produk utama pada masa hadapan? (1= langsung tidak, 5= paling berkemungkinan)',
    selectLikelihood: '1-5',
    whyQuestion: 'Mengapa?',
    submit: 'Hantar',
    brandOpinionWarning: 'Sila kongsi pendapat anda tentang jenama LD.',
    likelihoodWarning: 'Sila pilih skor dari 1 hingga 5.',
    likelihoodWhyWarning: 'Sila beritahu kami mengapa anda memilih skor tersebut.',
    sessionExpiredWarning: 'Sesi tamat. Sila mulakan semula dari langkah telefon.',
    incompleteWarning: 'Data kaji selidik tidak lengkap. Sila kembali dan lengkapkan langkah sebelumnya.',
    submitError: 'Tidak dapat menyimpan. Sila cuba lagi.',
  },
  tng: {
    title: 'TERIMA KASIH',
    subtitle: 'ATAS PENYERTAAN ANDA',
    smsNote: 'Anda akan menerima PIN penebusan e-Wallet melalui SMS',
    fallbackNote:
      'Baucar anda tidak dapat dimuatkan dalam paparan ini. Jika anda baru sahaja melengkapkan kaji selidik, buka halaman ini semula dari langkah kaji selidik dalam tab pelayar yang sama.',
  },
};

const translations: Record<Lang, AppTranslations> = { en, bm };

export function getTranslations(lang: Lang): AppTranslations {
  return translations[lang];
}
